/**
 * Tamil Nadu Districts Configuration
 * Complete list of all 38 districts in Tamil Nadu
 */

export const TAMIL_NADU_DISTRICTS = [
  { value: 'Ariyalur', label: 'Ariyalur' },
  { value: 'Chengalpattu', label: 'Chengalpattu' },
  { value: 'Chennai', label: 'Chennai' },
  { value: 'Coimbatore', label: 'Coimbatore' },
  { value: 'Cuddalore', label: 'Cuddalore' },
  { value: 'Dharmapuri', label: 'Dharmapuri' },
  { value: 'Dindigul', label: 'Dindigul' },
  { value: 'Erode', label: 'Erode' },
  { value: 'Kallakurichi', label: 'Kallakurichi' },
  { value: 'Kanchipuram', label: 'Kanchipuram' },
  { value: 'Kanyakumari', label: 'Kanyakumari' },
  { value: 'Karur', label: 'Karur' },
  { value: 'Krishnagiri', label: 'Krishnagiri' },
  { value: 'Madurai', label: 'Madurai' },
  { value: 'Mayiladuthurai', label: 'Mayiladuthurai' },
  { value: 'Nagapattinam', label: 'Nagapattinam' },
  { value: 'Namakkal', label: 'Namakkal' },
  { value: 'Nilgiris', label: 'Nilgiris' },
  { value: 'Perambalur', label: 'Perambalur' },
  { value: 'Pudukkottai', label: 'Pudukkottai' },
  { value: 'Ramanathapuram', label: 'Ramanathapuram' },
  { value: 'Ranipet', label: 'Ranipet' },
  { value: 'Salem', label: 'Salem' },
  { value: 'Sivaganga', label: 'Sivaganga' },
  { value: 'Tenkasi', label: 'Tenkasi' },
  { value: 'Thanjavur', label: 'Thanjavur' },
  { value: 'Theni', label: 'Theni' },
  { value: 'Thoothukudi', label: 'Thoothukudi (Tuticorin)' },
  { value: 'Tiruchirappalli', label: 'Tiruchirappalli (Trichy)' },
  { value: 'Tirunelveli', label: 'Tirunelveli' },
  { value: 'Tirupattur', label: 'Tirupattur' },
  { value: 'Tiruppur', label: 'Tiruppur' },
  { value: 'Tiruvallur', label: 'Tiruvallur' },
  { value: 'Tiruvannamalai', label: 'Tiruvannamalai' },
  { value: 'Tiruvarur', label: 'Tiruvarur' },
  { value: 'Vellore', label: 'Vellore' },
  { value: 'Viluppuram', label: 'Viluppuram' },
  { value: 'Virudhunagar', label: 'Virudhunagar' }
];

/**
 * Get district by value
 */
export const getDistrictByValue = (value) => {
  return TAMIL_NADU_DISTRICTS.find(district => district.value === value);
};

/**
 * Search districts by name
 */
export const searchDistricts = (searchTerm) => {
  if (!searchTerm) return TAMIL_NADU_DISTRICTS;

  const lowerSearch = searchTerm.toLowerCase();
  return TAMIL_NADU_DISTRICTS.filter(district =>
    district.label.toLowerCase().includes(lowerSearch) ||
    district.value.toLowerCase().includes(lowerSearch)
  );
};

export default TAMIL_NADU_DISTRICTS;
